/**
 * Acordeón Mates Ramos.
 *
 * Botón + aria-expanded, un solo listener delegado y el panel animado con
 * grid-template-rows (la altura la resuelve el navegador, sin medir nada).
 * Mientras está cerrado el panel lleva `inert`, así el contenido oculto no
 * recibe foco ni lo lee un lector de pantalla.
 */
class MrAccordion extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('.mr-accordion__trigger') : null;
    if (!trigger || !this.contains(trigger)) return;

    const panel = document.getElementById(trigger.getAttribute('aria-controls') ?? '');
    if (!panel) return;

    const willOpen = trigger.getAttribute('aria-expanded') !== 'true';

    trigger.setAttribute('aria-expanded', String(willOpen));
    panel.dataset.open = String(willOpen);
    panel.toggleAttribute('inert', !willOpen);
  };
}

if (!customElements.get('mr-accordion')) {
  customElements.define('mr-accordion', MrAccordion);
}
